// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class IIsPatientRegisteredRequestModel {
    static getAttributeTypeMap() {
        return IIsPatientRegisteredRequestModel.attributeTypeMap;
    }
}
IIsPatientRegisteredRequestModel.discriminator = undefined;
IIsPatientRegisteredRequestModel.attributeTypeMap = [
    {
        "name": "firstName",
        "baseName": "firstName",
        "type": "string"
    },
    {
        "name": "lastName",
        "baseName": "lastName",
        "type": "string"
    },
    {
        "name": "dob",
        "baseName": "dob",
        "type": "Date"
    },
    {
        "name": "gender",
        "baseName": "gender",
        "type": "Gender"
    },
    {
        "name": "zip",
        "baseName": "zip",
        "type": "string"
    }
];
//# sourceMappingURL=iIsPatientRegisteredRequestModel.js.map